import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  if (user) {
    navigate("/admin/dashboard");
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#8B0000] flex items-center justify-center mx-auto mb-4">
            <Lock size={28} className="text-white" />
          </div>
          <h1 className="text-3xl font-black text-white" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
            Administration
          </h1>
          <p className="text-[#A1A1AA] text-sm mt-2">VGI Construct - Panneau d'administration</p>
        </div>

        <div className="bg-[#141414] border border-[#27272A] p-6 sm:p-8">
          <form onSubmit={handleSubmit} data-testid="admin-login-form" className="space-y-4">
            <div>
              <label className="text-[#A1A1AA] text-xs uppercase tracking-wider block mb-2">Email</label>
              <input
                data-testid="admin-email"
                type="email"
                required
                className="input-dark"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="info@vgiconstruct.be"
              />
            </div>
            <div>
              <label className="text-[#A1A1AA] text-xs uppercase tracking-wider block mb-2">Mot de passe</label>
              <input
                data-testid="admin-password"
                type="password"
                required
                className="input-dark"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Mot de passe"
              />
            </div>

            {error && <p data-testid="admin-login-error" className="text-red-500 text-sm">{error}</p>}

            <button
              type="submit"
              data-testid="admin-login-submit"
              disabled={loading}
              className="btn-primary w-full disabled:opacity-50"
            >
              {loading ? "Connexion..." : "Se connecter"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
